function getCookie(cname) {
	const name = cname + '=';
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

function showCookieNotice() {
	if (!getCookie('cookie_notice')) {
		jQuery('body').addClass('js-show-cookie_notice');
	}

	jQuery('.js-cookie_notice_accept').on('click', function () {
		jQuery('body').removeClass('js-show-cookie_notice');
		document.cookie = 'cookie_notice=closed;path=/';
	});
}

export default showCookieNotice;
